import { render, staticRenderFns } from "./CollegeInfoForm.vue?vue&type=template&id=255e810c&scoped=true&"
import script from "./CollegeInfoForm.vue?vue&type=script&lang=js&"
export * from "./CollegeInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./CollegeInfoForm.vue?vue&type=style&index=0&id=255e810c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e810c",
  null
  
)

export default component.exports